// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "utf-8";

/*메시지 발송 부분*/
.send_msg{width: 460px;}
.send_msg .tab{margin-bottom: 15px;}
.send_msg .tab ul{display: flex;gap: 15px;}
.send_msg .tab ul li:last-child{margin-left: auto;}
.send_msg .tab ul li div{
    display: inline-flex;
    padding: 5px 14px;
    align-items: center;
    border-radius: 21px;
    border: 1px solid #51D7DF;
    background: #FFF;
    color: #51D7DF;
    font-size: 18px;
    font-weight: 700;
}

.send_msg .tab ul li.on div{
    background:#51D7DF;
    color: #fff;
}

.msg_con{
    height: 701px;
    border-radius: 20px;
    background: #FFF;
    box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);
    padding: 20px;
    box-sizing: border-box;
    position: relative;
}

.new_send textarea{
    border: 1px solid #EEE;
    width: 100%;
    resize: none;
    padding: 10px;
    height: 300px;
    border-radius: 10px;
    box-sizing: border-box;
}

.new_send .msg_date{
    margin-top: 20px;
    border-radius: 10px;
    border: 1px solid #EEE;
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
    gap:10px;align-items: center;
}
.new_send .msg_date label[for="rsv"]{
    margin-left:auto;
}
.new_send .msg_date label[for="send_date"] svg{
    position: relative;
    top: 2px;
}

.msg_date .date_container {
    display: flex;
    gap: 10px;
    align-items: center;    
    z-index: 10;
}

.new_send .msg_date #send_date{
    width: 180px;
    border-radius: 5px;
    background: #F6F6F6;
    font-size:12px;
    padding: 2px 6px 2px 6px;
    box-sizing: border-box;
}

.new_send .target{
    margin-top: 15px;
    height: 179px;
    border-radius: 10px;
    border: 1px solid #EEE;
    padding: 10px 20px;
    box-sizing: border-box;
}

.new_send .target svg{
    position: relative;
    top: 2px;
}
.new_send .cst_list{
    display: flex;
    margin-top: 10px;
    gap: 8px;
    flex-wrap: wrap;
}

.new_send .button #send_btn{
    width: 110px;
    height: 40px;
    border-radius: 20px;
    border: 1px solid #51D7DF;
    background: #51D7DF;
    color: #fff;
    position: absolute;right: 20px; bottom: 20px;
}
/* 템플릿 */

.template .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.template label { /* template title */
    font-size: 14px;
    font-weight: 400;
}

.template #template_name {
    width: 100%;
    height: 40px;
    border: 1px solid #EEE;
    border-radius: 10px;
    padding: 10px;
    margin-bottom:10px;
}

.template .top button {
    padding: 5px 10px;
    border-radius: 5px;
    background: #51D7DF;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
}

.template textarea {
    width: 100%;
    height: 120px;
    border: 1px solid #EEE;
    border-radius: 10px;
    padding: 10px;
    resize: none;
    margin-top: 10px;
    margin-bottom:10px;
}

.template .btn_list {
    display: flex;
    justify-content: space-between;
    align-items: center;

    gap: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
}

#del_btn {
    width:110px;
    padding: 10px 20px;
    border-radius: 15px;
    background: #DDDDDD;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
}

#save_btn {
    width:110px;
    padding: 10px 20px;
    border-radius: 15px;
    background: #51D7DF;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
}

.template .msg_date{
    margin-top: 20px;
    border-radius: 10px;
    border: 1px solid #EEE;
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
    gap:10px;align-items: center;
}
.template .msg_date label[for="rsv"]{
    margin-left:auto;
}
.template .msg_date label[for="send_date"] svg{
    position: relative;
    top: 2px;
}
.template .msg_date #send_date{
    width: 180px;
    border-radius: 5px;
    background: #F6F6F6;
    font-size:12px;
    padding: 2px 6px 2px 6px;
    box-sizing: border-box;
}

.template .target{
    margin-top: 15px;
    height: 135px;
    border-radius: 10px;
    border: 1px solid #EEE;
    padding: 10px 20px;
    box-sizing: border-box;
    overflow-y: scroll;
}

.template .target svg{
    position: relative;
    top: 2px;
}
.template .cst_list{
    display: flex;
    margin-top: 10px;
    gap: 8px;
    flex-wrap: wrap;
}

.template .button #send_btn{
    width: 110px;
    height: 40px;
    border-radius: 20px;
    border: 1px solid #51D7DF;
    background: #51D7DF;
    color: #fff;
    position: absolute; right: 20px; bottom: 20px;
}

/*발송리스트*/
.send_list {
    width:100%;
    height:100%;
    overflow-y: scroll;
}

.send_list .send_item{
    border-radius: 10px;
    background: #FFF;
    box-shadow: 4px 4px 10px 0px rgba(207, 207, 207, 0.25);
}

.send_item{
    padding: 14px;
    margin-bottom: 15px;
}
.send_item:last-child{margin-bottom: 0;}
.send_item .date{
    color: #7D7D7D;
}

.send_item .send_con {
    margin-top:5px;
    width: 100%;
    font-weight: 500;
    overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
}

.send_item .send_target {
    margin-top:10px;
    display: flex;
    gap:10px;
    align-items: center;
}

.send_target .cst_list{
    margin-top:10px;
    display: flex;
    gap:10px;
    align-items: center;
    overflow-x: scroll;
}

.send_target label{
    flex-shrink:0;
}

/*고객리스트*/
.customer_list {
    display: flex;
    flex:1 1;
    justify-content: space-between;
    gap: 10px;
}
.customer_list .customer{
    flex-grow: 1;
    flex-shrink: 0;
    border-radius: 20px;
    height: 751px;
    background: #FFF;
    box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);
    padding: 14px 12px;
    box-sizing: border-box;
    transition: all ease 0.5s;
    -moz-transition: all ease 0.5s;/* Firefox 4 */
    -webkit-transition: all ease 0.5s; /* Safari and Chrome */
    -o-transition: all ease 0.5s;/* Opera */
    -ms-transition: all ease 0.5s;/* Explorer 10 */
}
.customer_list .customer.selected {
    width:40%;
}
.customer_list .customer.selected .wrap_box{
    display: flex;
    justify-content: space-between;
    gap:10px;
    flex-wrap: wrap;
    align-items: flex-start;
    align-content: flex-start;
}

.customer_list .customer.selected .wrap_box .cst_item{
    width: 42%; 
}

.customer_list .customer .top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    margin-bottom: 40px;
}
.customer_list .customer .top .num{
    margin-left: auto;
    font-size: 16px;
    font-weight: 500;
}
.customer_list .customer .top label{
    font-size: 20px;
    font-weight: 700;
}
.customer .wrap_box{
    height: 650px;
}
.default_info {display: block; width: 100%;}
.customer .wrap_box .cst_item{
    flex-grow: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 6px;
    background: white;
    border: 1.5px solid #F6F6F6;
    padding: 6px 10px;
    cursor: pointer;
    margin-bottom: 12px;
}
.customer .wrap_box .cst_item .profile_container {
    display:flex;
    flex-direction: row;
    gap:10px;
    align-items: center;
}

.customer .wrap_box .cst_item:last-child{margin-bottom: 0;}
.customer .wrap_box .cst_item .profile {
    width: 27px;
    height: 27px;
    border-radius: 50%;
    overflow:hidden;
}
.customer .wrap_box .cst_item .tit{
    font-size:14px;
    font-weight: 500;
}

.customer .wrap_box .cst_item.on{
    border: 1.5px solid #51D7DF;
}

/* customer list css */
.cst_list .cst_item {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    gap:8px;
    padding: 2px 5px;
    background:#fff;
    color: black;
    bordeR: 1px solid #51D7DF;
    border-radius:10px;
    cursor:pointer;
}

.cst_list .cst_item span {
    max-width:90px;
    color: black;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    
}
.cst_list .cst_item button {
    background: #51D7DF;
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 3px 5px;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/css/customer.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB,YAAY;AACZ,UAAU,YAAY,CAAC;AACvB,eAAe,mBAAmB,CAAC;AACnC,kBAA4D,aAAa,CAAC,SAAS,CAAC;AACpF,gCAAgC,iBAAiB,CAAC;AAClD;IAGI,oBAAoB;IACpB,iBAAiB;IAGT,mBAAmB;IAC3B,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAER,sDAAsD;IAC9D,aAAa;IAEL,sBAAsB;IAC9B,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IAEX,sBAAsB;AAClC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAGlB,aAAa;IACb,8BAA8B;IAC9B,QAAQ,CAAkD,mBAAmB;AACjF;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IAGI,aAAa;IACb,SAAS;IAGH,mBAAmB;IACzB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAEV,sBAAsB;AAClC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;AACA;IAGI,aAAa;IACb,gBAAgB;IAChB,QAAQ;IAEJ,eAAe;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,kBAAkB,CAAC,WAAW,EAAE,YAAY;AAChD;AACA,QAAQ;;AAER;IAGI,aAAa;IAGL,8BAA8B;IAG9B,mBAAmB;IAC3B,mBAAmB;AACvB;;AAEA,kBAAkB,mBAAmB;IACjC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IAGI,aAAa;IAGb,8BAA8B;IAG9B,mBAAmB;;IAEnB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAGlB,aAAa;IACb,8BAA8B;IAC9B,QAAQ,CAAkD,mBAAmB;AACjF;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,QAAQ;AACZ;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAEV,sBAAsB;IAC9B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;AACA;IAGI,aAAa;IACb,gBAAgB;IAChB,QAAQ;IAEJ,eAAe;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,kBAAkB,EAAE,WAAW,EAAE,YAAY;AACjD;;AAEA,QAAQ;AACR;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAER,sDAAsD;AAClE;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA,sBAAsB,gBAAgB,CAAC;AACvC;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,gBAAgB;MAEX,uBAAuB;MAC1B,oBAAoB;MACpB,qBAAqB;MACrB,4BAA4B;AAClC;;AAEA;IACI,eAAe;IAGf,aAAa;IACb,QAAQ;IAGR,mBAAmB;AACvB;;AAEA;IACI,eAAe;IAGf,aAAa;IACb,QAAQ;IAGA,mBAAmB;IAC3B,kBAAkB;AACtB;;AAEA;IAEQ,aAAa;AACrB;;AAEA,QAAQ;AACR;IAGI,aAAa;IACb,QAAM;IAGE,8BAA8B;IACtC,SAAS;AACb;AACA;IAGY,YAAY;IAEhB,cAAc;IAClB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAER,sDAAsD;IAC9D,kBAAkB;IAEV,sBAAsB;IAC9B,yBAAyB;IACzB,8BAA8B,CAAC,cAAc;IAC7C,iCAAiC,EAAE,sBAAsB;IACzD,4BAA4B,CAAC,UAAU;IACvC,6BAA6B,CAAC,gBAAgB;AAClD;AACA;IACI,SAAS;AACb;AACA;IAGI,aAAa;IAGL,8BAA8B;IACtC,QAAQ;IAEJ,eAAe;IAGX,uBAAuB;IAE3B,yBAAyB;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IAGI,aAAa;IAGL,8BAA8B;IAG9B,mBAAmB;IAC3B,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA,eAAe,cAAc,EAAE,WAAW,CAAC;AAC3C;IAGY,YAAY;IAGpB,aAAa;IAGL,8BAA8B;IAG9B,mBAAmB;IAC3B,kBAAkB;IAClB,iBAAiB;IACjB,2BAA2B;IAC3B,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,QAAQ;IAGA,mBAAmB;AAC/B;;AAEA,yCAAyC,gBAAgB,CAAC;AAC1D;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,sBAAsB;AACtB;IAGI,aAAa;IAGL,uBAAuB;IAGvB,mBAAmB;IAC3B,mBAAmB;IACnB,OAAO;IACP,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;;AAE3B;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB","sourcesContent":["@charset \"utf-8\";\n\n/*메시지 발송 부분*/\n.send_msg{width: 460px;}\n.send_msg .tab{margin-bottom: 15px;}\n.send_msg .tab ul{display: -webkit-box;display: -ms-flexbox;display: flex;gap: 15px;}\n.send_msg .tab ul li:last-child{margin-left: auto;}\n.send_msg .tab ul li div{\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    padding: 5px 14px;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    border-radius: 21px;\n    border: 1px solid #51D7DF;\n    background: #FFF;\n    color: #51D7DF;\n    font-size: 18px;\n    font-weight: 700;\n}\n\n.send_msg .tab ul li.on div{\n    background:#51D7DF;\n    color: #fff;\n}\n\n.msg_con{\n    height: 701px;\n    border-radius: 20px;\n    background: #FFF;\n    -webkit-box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);\n            box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);\n    padding: 20px;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    position: relative;\n}\n\n.new_send textarea{\n    border: 1px solid #EEE;\n    width: 100%;\n    resize: none;\n    padding: 10px;\n    height: 300px;\n    border-radius: 10px;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n}\n\n.new_send .msg_date{\n    margin-top: 20px;\n    border-radius: 10px;\n    border: 1px solid #EEE;\n    padding: 10px 20px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    justify-content: space-between;\n    gap:10px;-webkit-box-align: center;-ms-flex-align: center;align-items: center;\n}\n.new_send .msg_date label[for=\"rsv\"]{\n    margin-left:auto;\n}\n.new_send .msg_date label[for=\"send_date\"] svg{\n    position: relative;\n    top: 2px;\n}\n\n.msg_date .date_container {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    gap: 10px;\n    -webkit-box-align: center;\n       -ms-flex-align: center;\n          align-items: center;    \n    z-index: 10;\n}\n\n.new_send .msg_date #send_date{\n    width: 180px;\n    border-radius: 5px;\n    background: #F6F6F6;\n    font-size:12px;\n    padding: 2px 6px 2px 6px;\n    box-sizing: border-box;\n}\n\n.new_send .target{\n    margin-top: 15px;\n    height: 179px;\n    border-radius: 10px;\n    border: 1px solid #EEE;\n    padding: 10px 20px;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n}\n\n.new_send .target svg{\n    position: relative;\n    top: 2px;\n}\n.new_send .cst_list{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin-top: 10px;\n    gap: 8px;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\n\n.new_send .button #send_btn{\n    width: 110px;\n    height: 40px;\n    border-radius: 20px;\n    border: 1px solid #51D7DF;\n    background: #51D7DF;\n    color: #fff;\n    position: absolute;right: 20px; bottom: 20px;\n}\n/* 템플릿 */\n\n.template .top {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    margin-bottom: 10px;\n}\n\n.template label { /* template title */\n    font-size: 14px;\n    font-weight: 400;\n}\n\n.template #template_name {\n    width: 100%;\n    height: 40px;\n    border: 1px solid #EEE;\n    border-radius: 10px;\n    padding: 10px;\n    margin-bottom:10px;\n}\n\n.template .top button {\n    padding: 5px 10px;\n    border-radius: 5px;\n    background: #51D7DF;\n    color: #fff;\n    font-size: 14px;\n    cursor: pointer;\n}\n\n.template textarea {\n    width: 100%;\n    height: 120px;\n    border: 1px solid #EEE;\n    border-radius: 10px;\n    padding: 10px;\n    resize: none;\n    margin-top: 10px;\n    margin-bottom:10px;\n}\n\n.template .btn_list {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    justify-content: space-between;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n\n    gap: 10px;\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n#del_btn {\n    width:110px;\n    padding: 10px 20px;\n    border-radius: 15px;\n    background: #DDDDDD;\n    color: #fff;\n    font-size: 14px;\n    cursor: pointer;\n}\n\n#save_btn {\n    width:110px;\n    padding: 10px 20px;\n    border-radius: 15px;\n    background: #51D7DF;\n    color: #fff;\n    font-size: 14px;\n    cursor: pointer;\n}\n\n.template .msg_date{\n    margin-top: 20px;\n    border-radius: 10px;\n    border: 1px solid #EEE;\n    padding: 10px 20px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    justify-content: space-between;\n    gap:10px;-webkit-box-align: center;-ms-flex-align: center;align-items: center;\n}\n.template .msg_date label[for=\"rsv\"]{\n    margin-left:auto;\n}\n.template .msg_date label[for=\"send_date\"] svg{\n    position: relative;\n    top: 2px;\n}\n.template .msg_date #send_date{\n    width: 180px;\n    border-radius: 5px;\n    background: #F6F6F6;\n    font-size:12px;\n    padding: 2px 6px 2px 6px;\n    box-sizing: border-box;\n}\n\n.template .target{\n    margin-top: 15px;\n    height: 135px;\n    border-radius: 10px;\n    border: 1px solid #EEE;\n    padding: 10px 20px;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    overflow-y: scroll;\n}\n\n.template .target svg{\n    position: relative;\n    top: 2px;\n}\n.template .cst_list{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin-top: 10px;\n    gap: 8px;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\n\n.template .button #send_btn{\n    width: 110px;\n    height: 40px;\n    border-radius: 20px;\n    border: 1px solid #51D7DF;\n    background: #51D7DF;\n    color: #fff;\n    position: absolute; right: 20px; bottom: 20px;\n}\n\n/*발송리스트*/\n.send_list {\n    width:100%;\n    height:100%;\n    overflow-y: scroll;\n}\n\n.send_list .send_item{\n    border-radius: 10px;\n    background: #FFF;\n    -webkit-box-shadow: 4px 4px 10px 0px rgba(207, 207, 207, 0.25);\n            box-shadow: 4px 4px 10px 0px rgba(207, 207, 207, 0.25);\n}\n\n.send_item{\n    padding: 14px;\n    margin-bottom: 15px;\n}\n.send_item:last-child{margin-bottom: 0;}\n.send_item .date{\n    color: #7D7D7D;\n}\n\n.send_item .send_con {\n    margin-top:5px;\n    width: 100%;\n    font-weight: 500;\n    overflow: hidden;\n      -o-text-overflow: ellipsis;\n         text-overflow: ellipsis;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n}\n\n.send_item .send_target {\n    margin-top:10px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    gap:10px;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.send_target .cst_list{\n    margin-top:10px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    gap:10px;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    overflow-x: scroll;\n}\n\n.send_target label{\n    -ms-flex-negative:0;\n        flex-shrink:0;\n}\n\n/*고객리스트*/\n.customer_list {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    flex:1;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    gap: 10px;\n}\n.customer_list .customer{\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    -ms-flex-negative: 0;\n        flex-shrink: 0;\n    border-radius: 20px;\n    height: 751px;\n    background: #FFF;\n    -webkit-box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);\n            box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);\n    padding: 14px 12px;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    transition: all ease 0.5s;\n    -moz-transition: all ease 0.5s;/* Firefox 4 */\n    -webkit-transition: all ease 0.5s; /* Safari and Chrome */\n    -o-transition: all ease 0.5s;/* Opera */\n    -ms-transition: all ease 0.5s;/* Explorer 10 */\n}\n.customer_list .customer.selected {\n    width:40%;\n}\n.customer_list .customer.selected .wrap_box{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    gap:10px;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -webkit-box-align: start;\n        -ms-flex-align: start;\n            align-items: flex-start;\n    -ms-flex-line-pack: start;\n        align-content: flex-start;\n}\n\n.customer_list .customer.selected .wrap_box .cst_item{\n    width: 42%; \n}\n\n.customer_list .customer .top{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 10px;\n    margin-bottom: 40px;\n}\n.customer_list .customer .top .num{\n    margin-left: auto;\n    font-size: 16px;\n    font-weight: 500;\n}\n.customer_list .customer .top label{\n    font-size: 20px;\n    font-weight: 700;\n}\n.customer .wrap_box{\n    height: 650px;\n}\n.default_info {display: block; width: 100%;}\n.customer .wrap_box .cst_item{\n    -webkit-box-flex: 0;\n        -ms-flex-positive: 0;\n            flex-grow: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    border-radius: 6px;\n    background: white;\n    border: 1.5px solid #F6F6F6;\n    padding: 6px 10px;\n    cursor: pointer;\n    margin-bottom: 12px;\n}\n.customer .wrap_box .cst_item .profile_container {\n    display:flex;\n    flex-direction: row;\n    gap:10px;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n\n.customer .wrap_box .cst_item:last-child{margin-bottom: 0;}\n.customer .wrap_box .cst_item .profile {\n    width: 27px;\n    height: 27px;\n    border-radius: 50%;\n    overflow:hidden;\n}\n.customer .wrap_box .cst_item .tit{\n    font-size:14px;\n    font-weight: 500;\n}\n\n.customer .wrap_box .cst_item.on{\n    border: 1.5px solid #51D7DF;\n}\n\n/* customer list css */\n.cst_list .cst_item {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    flex-direction: row;\n    gap:8px;\n    padding: 2px 5px;\n    background:#fff;\n    color: black;\n    bordeR: 1px solid #51D7DF;\n    border-radius:10px;\n    cursor:pointer;\n}\n\n.cst_list .cst_item span {\n    max-width:90px;\n    color: black;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    \n}\n.cst_list .cst_item button {\n    background: #51D7DF;\n    color: #fff;\n    border: none;\n    border-radius: 8px;\n    padding: 3px 5px;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
